import { render, staticRenderFns } from "./IletisimList.vue?vue&type=template&id=15114f50"
import script from "./IletisimList.vue?vue&type=script&lang=ts"
export * from "./IletisimList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports